var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_911_7877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83464 4.16683V1.66683C5.83464 1.44582 5.92243 1.23385 6.07871 1.07757C6.23499 0.921293 6.44696 0.833496 6.66797 0.833496H13.3346C13.5556 0.833496 13.7676 0.921293 13.9239 1.07757C14.0802 1.23385 14.168 1.44582 14.168 1.66683V4.16683H17.5013C17.7223 4.16683 17.9343 4.25463 18.0906 4.41091C18.2468 4.56719 18.3346 4.77915 18.3346 5.00016V16.6668C18.3346 16.8878 18.2468 17.0998 18.0906 17.2561C17.9343 17.4124 17.7223 17.5002 17.5013 17.5002H2.5013C2.28029 17.5002 2.06833 17.4124 1.91205 17.2561C1.75577 17.0998 1.66797 16.8878 1.66797 16.6668V5.00016C1.66797 4.77915 1.75577 4.56719 1.91205 4.41091C2.06833 4.25463 2.28029 4.16683 2.5013 4.16683H5.83464ZM16.668 10.8335H3.33464V15.8335H16.668V10.8335ZM16.668 5.8335H3.33464V9.16683H5.83464V7.50016H7.5013V9.16683H12.5013V7.50016H14.168V9.16683H16.668V5.8335ZM7.5013 2.50016V4.16683H12.5013V2.50016H7.5013Z",
    fill: "#EEAC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_911_7877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.5b7c9da8d22ce120e7d1cd658d94ed16.svg";
export { ForwardRef as ReactComponent };